import React, { useState, useEffect } from 'react';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const ABCDFooterVariant = (props) => {
  const footerInfo = props?.fields?.data?.footer;

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const mobileaccordionItems = document.querySelectorAll('.footer_mobile_acc_item');

      mobileaccordionItems.forEach((item) => {
        item.addEventListener('click', function () {
          const isActive = this.classList.contains('mobile-border-radius');
          mobileaccordionItems.forEach((el) => {
            el.classList.remove('mobile-border-radius');
          });
          if (!isActive) {
            this.classList.add('mobile-border-radius');
          }
        });
      });

      // Clean up event listeners on unmount
      return () => {
        mobileaccordionItems.forEach((item) => {
          item.removeEventListener('click', () => {});
        });
      };
    }
  }, []);

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const chunks = chunkArray(
    footerInfo?.tabs?.targetItems?.filter((item) => item.mobileOnly.value === ''),
    4
  );

  const [activeTab, setActiveTab] = useState('pills-footer1'); // Default active tab

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <footer>
      <div className="footer_accordion accordion disclaimer_accordion" id="footer_accordion">
        <RichText field={footerInfo?.Disclaimer} />
      </div>
      <div className="main_footer_wrapper">
        <div className="footer_left_wrapper">
          <div className="bran_logo_footer">
            <a href={footerInfo?.LogoCTA?.url}>
              <Image field={footerInfo?.Logo} loading="lazy" />
            </a>
          </div>
          <div className="footer_socials d-none d-lg-flex">
            <ul className="list-inline">
              {footerInfo?.SocialMedia?.targetItems[0]?.medias?.map((follow, index) => (
                <li className="list-inline-item" key={index}>
                  <a href={follow?.menuLink?.url}>
                    <Image field={follow?.menuIcon} loading="lazy" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {footerInfo?.LanguageOption?.value && (
            <div className="footer_language_options d-none d-lg-block">
              <RichText field={footerInfo?.LanguageOption} />
            </div>
          )}
          {footerInfo?.TollText && footerInfo?.IconCTA?.url && (
            <div className="footer_contact_info footer_option2">
              <div className="fci_Wrp">
                <span>
                  <img
                    src={footerInfo?.Icon?.src}
                    height={footerInfo?.Icon?.height}
                    width={footerInfo?.Icon?.width}
                  />
                </span>
                <div>
                  <Text tag="p" field={footerInfo?.TollText} />
                  <a href={footerInfo?.IconCTA?.url} target={footerInfo?.IconCTA?.target}>
                    {footerInfo?.IconCTA?.text}
                  </a>
                </div>
              </div>
              <div className="fci_Wrp d-none">
                <span>
                  <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/footer/white-email.svg" />
                </span>
                <div>
                  <p>Email ID</p>
                  <a href="mailto:abc@gmail.com">abc@gmail.com</a>
                </div>
              </div>
            </div>
          )}
          {footerInfo?.DownloadText?.value && (
            <div className="get_started">
              <Text tag="span" field={footerInfo?.DownloadText} />
              <ul>
                <li>
                  <a href={footerInfo?.PlayStore?.url} target={footerInfo?.PlayStore?.target}>
                    <img
                      src={footerInfo?.PlayStoreIcon?.src}
                      height={footerInfo?.PlayStoreIcon?.height}
                      width={footerInfo?.PlayStoreIcon?.width}
                    />
                    {footerInfo?.PlayStore?.text}
                  </a>
                </li>
                <li>
                  <a href={footerInfo?.AppStore?.url} target={footerInfo?.AppStore?.target}>
                    <img
                      src={footerInfo?.AppStoreIcon?.src}
                      height={footerInfo?.AppStoreIcon?.height}
                      width={footerInfo?.AppStoreIcon?.width}
                    />
                    {footerInfo?.AppStore?.text}
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
        <div className="footer_right_Wrapper footer_right_Wrapper_main_tabs d-none d-lg-block">
          {chunks.map((chunk, chunkIndex) => (
            <React.Fragment key={chunkIndex}>
              <ul className="nav" id="footer_tabs" role="tablist">
                {chunk.map((item, index) => {
                  const globalIndex = chunkIndex * 4 + index;
                  const tabId = `pills-footer${globalIndex + 1}`;
                  return (
                    <li className="nav-item" role="presentation" key={globalIndex}>
                      <button
                        className={`nav-link ${activeTab === tabId ? 'active' : ''}`}
                        id={`${tabId}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#${tabId}`}
                        type="button"
                        role="tab"
                        aria-controls={tabId}
                        aria-selected={activeTab === tabId ? 'true' : 'false'}
                        onClick={() => handleTabClick(tabId)}
                      >
                        {item?.menuTitle?.value}
                      </button>
                    </li>
                  );
                })}
              </ul>

              <div className="tab-content" id="footer_tabsContent">
                {chunk.map((tab, index) => {
                  const globalIndex = chunkIndex * 4 + index;
                  const tabId = `pills-footer${globalIndex + 1}`;
                  return (
                    <div
                      key={globalIndex}
                      className={`tab-pane fade ${activeTab === tabId ? 'show active' : ''}`}
                      id={tabId}
                      role="tabpanel"
                      aria-labelledby={`${tabId}-tab`}
                    >
                      {tab?.tabs_secondary?.map((item, secIndex) => (
                        <div className="footer_acc_links" key={secIndex}>
                          <span>
                            {item?.ctaLink?.url ? (
                              <a href={item?.ctaLink?.url} target={item?.ctaLink?.target}>
                                {item?.heading?.value}
                              </a>
                            ) : (
                              item?.heading?.value
                            )}
                          </span>
                          <ul className="list-inline">
                            {item?.tabs?.map((secTab, secTabIndex) => (
                              <li key={secTabIndex} className="list-inline-item">
                                <a href={secTab?.menuLink?.url} target={secTab?.menuLink?.target}>
                                  {secTab?.menuTitle?.value}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="mobile_accordion_Wrapper d-lg-none">
          <div className="footer_accordion accordion" id="mobile_footer_accordion">
            {footerInfo?.tabs?.targetItems?.map((item, index) => (
              <div className="accordion-item footer_mobile_acc_item" key={index}>
                <div
                  className="accordion-header"
                  id={`mobile_footer_accordion_panels-headingTwo-${index}`}
                >
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#mobile_footer_accordion_panels-collapseTwo-${index}`}
                    aria-expanded="true"
                    aria-controls={`mobile_footer_accordion_panels-collapseTwo-${index}`}
                  >
                    {item?.menuTitle?.value}
                  </button>
                </div>
                <div
                  id={`mobile_footer_accordion_panels-collapseTwo-${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`mobile_footer_accordion_panels-headingTwo-${index}`}
                  data-bs-parent="#mobile_footer_accordion"
                >
                  <div className="accordion-body">
                    {item?.tabs_secondary?.map((secItem, secIndex) => (
                      <div className="mobile_url_acc_wrapper" key={secIndex}>
                        <span className="mobile_accordion_url_head">{secItem?.heading?.value}</span>
                        <ul>
                          {secItem?.tabs?.map((tab, tabIndex) => (
                            <li key={tabIndex}>
                              <a href={tab.menuLink?.url} target={tab?.menuLink?.target}>
                                {tab?.menuTitle?.value}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="footer_socials d-lg-none">
          <ul className="list-inline">
            {footerInfo?.SocialMedia?.targetItems[0]?.medias?.map((follow, index) => (
              <li className="list-inline-item" key={index}>
                <a href={follow?.menuLink?.url} target={follow?.menuLink?.target}>
                  <Image field={follow?.menuIcon} loading="lazy" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="footer_accordion accordion" id="footer_accordion">
        <RichText field={footerInfo?.Riders} />
      </div>
      {footerInfo?.RedRibonText?.value && (
        <div className="footer_red_strip">
          <div className="copyright_div">
            <p>{footerInfo?.RedRibonText?.value}</p>
          </div>
          <div className="footer_strip_socil">
            <ul className="list-inline">
              {footerInfo?.SocialMediaRibon?.targetItems[0]?.medias?.map((follow, index) => (
                <li className="list-inline-item" key={index}>
                  <a href={follow?.menuLink?.url}>
                    <Image field={follow?.menuIcon} loading="lazy" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </footer>
  );
};

export default ABCDFooterVariant;
